<template>
  <div>
    <GlobalInfoBar>
      权益列表
    </GlobalInfoBar>
    <GlobalChunk :padding="[20, 20, 20, 20]">
      <GlobalForm :form-item-list="formItemList" :inline="true" round @handleConfirm="query" confirmBtnName="查询">
        <div slot="AddSlot">
          <el-button size="small" type="primary" icon="el-icon-plus" @click="addInterests">添加权益</el-button>
        </div>
      </GlobalForm>
      <span style="color: red;font-size: 15px;">注：此权益列表中的权益为默认为门店商家配置的权益</span>
      <GlobalTable style="margin-top: 15px;" ref="GlobalTable" :columns="tableColumns" :data="tableData"
        :currentPage="curPage" :total="totalElements" @handleCurrentChange="currentChange">
        <el-table-column label="使用商家范围" slot="interest_model" align="center">
          <template slot-scope="{ row }">
            <span>{{ row.interest_model == 1 ? '全部商家' : '指定商家' }}</span>
          </template>
        </el-table-column>
        <el-table-column label="商家数量" slot="store_num" align="center">
          <template slot-scope="{ row }">
            <span style="color: #0981FF;cursor: pointer;" v-if="/^-?\d+(\.\d+)?$/.test(row.store_num)"
              @click="addOrEditMerchant(row)"> {{ row.store_num }} </span>
            <span v-else>{{ row.store_num }}</span>
          </template>
        </el-table-column>
        <el-table-column label="门店后台展示/隐藏" slot="is_open" align="center">
          <template slot-scope="{ row }">
            <el-switch v-model="row.is_open" @change="switchChange(row)">
            </el-switch>
          </template>
        </el-table-column>
        <el-table-column label="操作" slot="operation" align="center" width="100">
          <template slot-scope="{ row }">
            <el-button type="text" @click="editInfo(row)">编辑</el-button>
          </template>
        </el-table-column>
      </GlobalTable>
    </GlobalChunk>

    <el-dialog :title="dialog.form.interest_id ? '编辑权益' : '新增权益'" :visible.sync="interestsVisible" width="900px"
      :before-close="interestsClose">
      <el-form ref="interestsForm" :model="dialog.form" label-width="80px" size="small" class="dialog-form"
        :rules="dialog.rules">
        <el-form-item prop="interest_name" label="权益名称">
          <el-input v-model="dialog.form.interest_name" placeholder="请输入权益名称"></el-input>
        </el-form-item>
        <el-form-item prop="interest_content" label="权益内容">
          <el-input type="textarea" v-model="dialog.form.interest_content" placeholder="请输入权益内容"></el-input>
        </el-form-item>
        <el-form-item prop="interest_model" label="使用商家范围">
          <el-radio v-model="dialog.form.interest_model" :label="1" style="display: block;margin: 10px;">全部商家</el-radio>
          <el-radio v-model="dialog.form.interest_model" :label="2" style="display: block;margin: 10px;">指定商家 已选择 <span
              style="cursor: pointer;color: #0981FF;" @click="addOrEditMerchant()">添加商家</span></el-radio>
        </el-form-item>
        <div style="display: flex;width: 100%;justify-content: end;margin: 15px;">
          <el-button type="primary" size="small" plain @click="interestsClose">取消</el-button>
          <el-button type="primary" size="small" @click="confirm">确定</el-button>
        </div>
      </el-form>
    </el-dialog>

    <el-dialog title="选择/查看门店商" :visible.sync="merchantVisible" width="900px" :before-close="merchantClose">

      <div style="display: flex; width: 520px;justify-content: center;align-items: center; margin: 15px;">
        <div style="width: 110px;">商家名称：</div>
        <el-input style="margin: 0 5px;" v-model="store_name" placeholder="请输入商家名称"></el-input>
        <el-button type="primary" @click="searchStoreName">查询</el-button>
      </div>
      <div style="width: 800px;">
        <div style="display: flex;justify-content: center;">
          <el-transfer v-model="yesSelect" :data="noSelect" :titles="['未选择', '已选择']" :button-texts="['删除', '添加']"
            @change="transferHandleChange"></el-transfer>
        </div>

        <div style="display: flex;justify-content: space-between;margin-top: 15px;"> <el-pagination
            layout="prev, pager, next" :currentPage="noSelectPage" :total="noSelectTotal"
            @handleCurrentChange="noSelectCurrentChange">
          </el-pagination>
          <el-pagination layout="prev, pager, next" :currentPage="yesSelectPage" :total="yesSelectTotal"
            @handleCurrentChange="yesSelectCurrentChange">
          </el-pagination>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>


import {
  openOperate, interestsList, interestsStoreList, interestsStore, interestsStoreHandle, interestsSet, interestsInfo
} from "@/utils/request/membershipSystem";

export default {
  name: "list",
  data() {

    return {

      formItemList: [
        {
          key: 'interest_name',
          type: 'input',
          labelName: '权益名称:',
          placeholder: '请输入权益名称'
        }, {
          key: 'is_open',
          idKey: 'id',
          labelKey: 'name',
          type: 'selectFilterable',
          labelName: '权益状态:',
          option: [{
            id: null,
            name: "全部"
          }, {
            id: '1',
            name: "启用"
          }, {
            id: '0',
            name: "禁用"
          }],
          placeholder: '请选择权益状态'
        }
      ],
      tableColumns: [
        { label: "权益名称", prop: "interest_name" },
        { label: "权益内容", prop: "interest_content" },
        { slotName: "interest_model" },
        { slotName: "store_num" },
        { slotName: "is_open" },
        { label: "最新操作人", prop: "user_name" },
        { label: "最新操作时间", prop: "add_time" },
        { slotName: "operation" },
      ],
      tableData: [],
      curPage: 1,
      totalElements: 0,
      searchData: {},
      interestsVisible: false,
      dialog: {
        form: {
          interest_name: '',
          interest_content: '',
          interest_model: 1
        },
        rules: {
          interest_name: [
            { required: true, message: '请输入权益名称', trigger: 'blur' }
          ],
          interest_content: [
            { required: true, message: '请输入权益内容', trigger: 'blur' }
          ],
          interest_model: [
            { required: true, message: '请选择使用商家范围', trigger: 'blur' }
          ],
        },
      },
      editRow: null,
      merchantVisible: false,
      store_name: '',
      noSelect: [],
      noSelectPage: 1,
      noSelectTotal: 0,
      yesSelect: [],
      yesSelectPage: 1,
      yesSelectTotal: 0,
      store_str: null,
      onlyMerchant: false
    }
  },
  mounted() {
    this.interestsList()

  },
  methods: {
    interestsList() {
      interestsList({
        page: this.curPage,
        ...this.searchData
      }).then(res => {
        res.data.map((ele) => {
          ele.is_open = ele.is_open == 1 ? true : false
        })
        this.tableData = res.data || []

        this.totalElements = res.count || 0
        console.log('this.totalElements', this.totalElements);

      })
    },
    currentChange(page) {
      this.curPage = page
      this.interestsList()
    },
    query(data, cd) {
      this.searchData = data
      this.curPage = 1
      this.interestsList()
    },
    switchChange(row) {
      console.log(row);
      const { interest_id, is_open } = row
      this.$alert(`是否确认${is_open ? '开启' : '禁用'}？`, '确认弹窗', {
        confirmButtonText: '确定',
        callback: action => {
          if (action == 'confirm') {
            openOperate({
              type: '1',
              val: is_open ? 1 : 0,
              id: interest_id
            }).then(res => {
              this.$message.success(res.msg)
              this.interestsList()
            })
          } else {
            row.is_open = !is_open
          }
        }
      });

    },
    addInterests() {
      this.interestsVisible = true
      this.onlyMerchant = false
    },
    editInfo(row) {
      this.dialog.form = row
      this.editRow = row
      console.log('this.editRow===', this.editRow);
      console.log('this.dialog.form', this.dialog.form);
      this.onlyMerchant = false
      this.interestsStoreList()
      this.interestsStore(row)

      this.interestsVisible = true

    },
    confirm() {
      this.$refs.interestsForm.validate(valid => {
        if (valid) {

          console.log(this.dialog.form);
          const { interest_model, interest_content, interest_name } = this.dialog.form
          this.$alert(`是否确认${interest_model ? '编辑' : '新增'}？`, '确认弹窗', {
            confirmButtonText: '确定',
            callback: action => {
              if (action == 'confirm') {
                interestsSet({
                  interest_model, interest_content, interest_name,
                  interest_id: this.editRow?.interest_id,
                  store_str: !this.dialog.form.interest_id ? this.store_str : this.yesSelect.join(',')
                }).then(res => {
                  this.$message.success(res.msg || '操作成功')
                  this.reset()
                  this.interestsVisible = false
                }).catch(err => {
                })
              }
            }
          });

        }
      })
    },
    interestsClose() {
      this.interestsVisible = false
      this.reset()
    },
    interestsStoreList() {
      interestsStoreList({
        page: this.noSelectPage,
        store_name: this.store_name
      }).then(res => {
        this.noSelectTotal = res.count

        const arr = []
        res.data.forEach((ele, inx) => {
          arr.push({
            key: ele.store_id,
            label: `${inx + 1} ${ele.store_name}`
          })
        })
        this.noSelect = arr
      })
    },
    interestsStore(row) {
      const { interest_id } = row
      interestsStore({
        page: this.yesSelectPage,
        interest_id
      }).then(res => {
        this.yesSelectTotal = res.count

        const arr = []
        res.data.forEach((ele, inx) => {
          arr.push(ele.store_id)
        })
        this.yesSelect = arr

      })

    },
    addOrEditMerchant(row) {
      this.merchantVisible = true
      if (row) {
        this.editRow = row
        this.dialog.form = row
        this.onlyMerchant = true
      }
      console.log('this.editRow addOrEditMerchant', this.editRow);

      this.interestsStoreList()
      if (row) {
        this.interestsStore(row)
      }
    },
    transferHandleChange(value, direction, movedKeys) {
      console.log('value', value);
      console.log('direction', direction);
      console.log('movedKeys', movedKeys);
      console.log('this.editRow', this.editRow);

      if (this.editRow && this.dialog.form.interest_id) {
        this.$alert(`${direction == 'right' ? '此权益是否确认指定商家使用?' : '是否确认移除商家?'}`, '指定商家确认', {
          confirmButtonText: '确定',
          callback: action => {
            if (action == 'confirm') {

              const { interest_id } = this.editRow
              interestsStoreHandle({
                type: direction == 'right' ? '1' : '2',
                interest_id,
                store_str: movedKeys.join(',')
              }).then(res => {
                this.$message.success(res.msg || '操作成功')
                this.store_str = movedKeys.join(',')
              })
            } else if (action == 'cancel') {
              this.interestsStoreList()
              this.interestsStore(this.editRow)
            }
          }
        });
      }



    },
    merchantClose() {
      this.merchantVisible = false
      if (this.editRow && this.dialog.form.interest_id && this.onlyMerchant) {
        this.reset()
      }

    },
    searchStoreName() {
      this.interestsStoreList()
    },
    noSelectCurrentChange(page) {
      this.noSelectPage = page

    },
    yesSelectCurrentChange(page) {
      this.yesSelectPage = page

    },
    reset() {
      this.yesSelect = []
      this.noSelect = []
      this.editRow = {}
      this.dialog.form = {}
      this.searchData = ''
      this.curPage = 1
      this.interestsList()
    },
  }
}
</script>

<style scoped lang="scss">
/deep/ .el-form-item__label {
  width: 80px !important;
}

.search-box {
  display: flex;
  align-items: center;
  font-size: 15px;
  font-weight: 600;
}

.box-box {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
  padding: 0 10px;
  justify-content: space-between;
}

.search {
  display: flex;
  align-items: center;
  width: 300px;
  margin-right: 10px;
}

.timer-config {
  display: flex;
  align-items: center;
}

.timer {
  width: 360px !important;
  // height: 30px;
  // line-height: 30px !important;
}

.dialog-notice {
  color: red;
  margin-bottom: 20px;
}

.dialog-form {

  .el-input,
  .el-select {
    width: 300px;
  }
}

.dialog-btns {
  margin: 30px 0 30px 60px;

  .el-button {
    margin-left: 20px;
  }
}

.el-popover {
  .el-icon-warning {
    color: #FAAD14;
    margin-right: 5px;
    font-size: 16px;
  }

  .btns {
    text-align: right;
    margin-top: 20px;
  }
}

.delete-btn {
  color: red;
  margin-left: 10px;
}

.el-popover {
  position: relative;
}

.popover-sore-num {
  position: absolute;
  right: 20px;
  top: 20px;

  span {
    color: red;
  }
}

.no-count {
  color: #000;
  pointer-events: none;
}

.remark {
  max-width: 140px;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  cursor: pointer;
  display: inline-block
}
</style>
